import React from 'react';
import './style.scss';
import LocationIcon from '../../../icons/LocationIcon';
import { formatTime } from '../../../constants/date';


interface PropertyCardProps {
    title: string;
    address: string;
    city: string;
    state: string;
    zipcode: string;
    type: 'STR' | 'LTR';
    duration: any;
}


const PropertyCard: React.FC<PropertyCardProps> = ({ title, address, city, state, zipcode, type, duration }) => {

    return (
        <div className="property-card">
            <div className="property-header">
                <h3 className="property-title">{title}</h3>
                <div className="property-address">
                    <span className="location-icon"><LocationIcon /> </span>
                    {address}, {city}, {state} {zipcode}
                </div>
            </div>
            <div className="property-footer">
                <span className={`property-type ${type.toLowerCase()}`}>{type}</span>
                {duration && (
                    <span className="property-duration">{formatTime(duration)}</span>
                )}

            </div>
        </div>
    );
};

export default PropertyCard;